import React, { useState } from 'react';
import { motion } from 'framer-motion';

const menuData = {
  'CRUDI DI PESCE': [
    { name: 'Tartare di Ombrina', price: '17€', description: 'Servita con crudité di verdure' },
    { name: 'Tartare di Tonno', price: '17€', description: 'Con avocado e lime' },
    { name: 'Gamberi Rossi di Mazara', price: '15€', description: 'Con cioccolato fondente (3 pezzi)' },
    { name: 'Carpaccio di Spigola', price: '14€' },
    { name: 'Degustazione di Crudi', price: '26€' },
  ],
  'ANTIPASTI': [
    { name: 'Insalata di Polpo con Patate e Cipolla di Tropea', price: '14€' },
    { name: 'Insalata Ricca di Mare', price: '12€' },
    { name: 'Sauté di Cozze', price: '12€' },
    { name: 'Sauté di Vongole', price: '15€' },
    { name: 'Alici Fritte con Verdurine', price: '14€', description: 'E riduzione di balsamico' },
    { name: 'Salmone Fresco Marinato agli Agrumi', price: '14€' },
    { name: 'Tagliere Rovèscio', price: '15€', description: 'Selezione salumi e formaggi' },
    { name: 'Prosciutto Crudo San Daniele e Bufala', price: '14€', description: "Dell'Agro Pontino" },
  ],
  'BRUSCHETTE': [
    { name: 'Bruschetta Pomodoro e Basilico', price: '3,5€' },
    { name: 'Bruschetta Avocado, Salmone e Stracciatella', price: '8€' },
    { name: 'Bruschetta Burrata ed Alici', price: '6€' },
    { name: 'Bruschetta Cicoria e Provola Affumicata', price: '6€' },
    { name: 'Bruschetta Aglio, Sale e Olio', price: '3€' },
  ],
  'PRIMI PIATTI': [
    { name: 'Tonnarelli allo Scoglio', price: '15€' },
    { name: 'Spaghetti alle Vongole', price: '16€' },
    { name: 'Tagliolino Nero di Seppia con Tartare di Gamberi', price: '16€', description: 'Aglio olio peperoncino, gamberi marinati al lime' },
    { name: 'Riso Wok con Verdure Saltate', price: '14€', description: 'Cumino, zenzero, curry - con pollo o gamberi/calamari' },
    { name: 'Gnocchetti con Pomodorini e Stracciatella', price: '14€', description: 'Pesto di basilico' },
    { name: 'Tonnarelli Cacio e Pepe con Fiori di Zucca', price: '15€' },
    { name: 'Mezze Maniche alla Carbonara', price: '12€' },
    { name: "Mezze Maniche all'Amatriciana Classica", price: '12€' },
  ],
  'SECONDI': [
    { name: 'Frittura di Calamari e Gamberi', price: '18€' },
    { name: "Polpo Arrosto con Patate e Olio all'Nduja", price: '19€' },
    { name: 'Calamaro alla Piastra', price: '19€', description: 'Con radicchio e aceto balsamico' },
    { name: 'Filetto di Spigola alla Griglia', price: '19€', description: 'Con verdure grigliate' },
    { name: 'Trancio di Salmone su Crema di Asparagi', price: '19€' },
    { name: 'Galletto alla Diavola', price: '18€', description: 'Con verdure arrostite' },
    { name: 'Filetto di Manzo', price: "10€ l'etto", description: 'Con insalata di finocchi, olive e arancia' },
    { name: 'Tagliata di Black Angus Australiana', price: "12€ l'etto", description: 'Rucola, pachino e riduzione di balsamico' },
    { name: 'Bistecca di Black Angus Argentino', price: "11€ l'etto", description: 'Disossata, allevata a grano' },
    { name: 'Hamburger Rovèscio', price: '14€', description: 'Lattuga, pomodoro, formaggio e bacon croccante' },
  ],
  'CONTORNI': [
    { name: 'Insalata Mista', price: '5€' },
    { name: 'Cicoria Ripassata', price: '5€' },
    { name: 'Patate al Forno al Rosmarino', price: '5€' },
    { name: 'Verdure Arrostite', price: '5€' },
  ],
  'HEALTHY': [
    { name: 'Avocado Toast con Salmone', price: '10€', description: 'Pane integrale, avocado, uovo (sodo o al tegamino)' },
    { name: 'Insalata di Salmone con Avocado', price: '11€', description: 'E mandorle tostate' },
    { name: 'Bresaola Rucola e Scaglie di Grana', price: '12€' },
    { name: 'Spaghetto Integrale Pastificio Mancini', price: '9€', description: 'Al pomodoro e basilico' },
    { name: 'Tagliata di Pollo', price: '12€', description: 'Riso basmati e verdure grigliate' },
    { name: 'Insalatona Mista con Tonno', price: '11€', description: 'Uovo, pachino, olive, carote, lattuga' },
  ],
  'FRITTI': [
    { name: 'Supplì Classico', price: '2,5€' },
    { name: "Supplì 'Nduja", price: '3€' },
    { name: 'Supplì Cacio e Pepe', price: '3€' },
    { name: 'Sfizi di Pollo Homemade', price: '6,5€', description: 'Nuggets con confettura di cipolla' },
    { name: 'Olive Ascolane (4pz)', price: '4€' },
    { name: 'Fiore di Zucca in Pastella', price: '4,5€' },
    { name: 'Filetto di Baccalà', price: '4,5€' },
    { name: 'Pizzella Tricolore Fritta', price: '4€', description: 'Pomodoro, grana, basilico fresco' },
    { name: 'Mozzarella in Carrozza', price: '4,5€' },
    { name: 'Chips Croccanti di Patate', price: '4€' },
    { name: 'Fritto Misto', price: '11€', description: 'Supplì, pizzella, fiore di zucca, oliva, chips' },
  ],
  'PIZZE BIANCHE': [
    { name: 'Ortolana', price: '9€', description: 'Mozzarella, zucchine, melanzane, peperoni' },
    { name: 'Boscaiola', price: '9€', description: 'Mozzarella, salsiccia, funghi' },
    { name: 'Affumicata', price: '11€', description: 'Mozzarella, speck, provola affumicata' },
    { name: 'Tricolore', price: '11€', description: 'Mozzarella di bufala, pachino, basilico fresco' },
    { name: 'Quattro Formaggi', price: '11€', description: 'Mozzarella, gorgonzola DOP, provola affumicata, grana' },
    { name: 'Radicchia', price: '11€', description: 'Mozzarella, radicchio, gorgonzola DOP, noci' },
    { name: 'Norvegese', price: '12€', description: 'Mozzarella, salmone, rucola' },
    { name: 'San Daniele', price: '12€', description: 'Mozzarella, prosciutto San Daniele, rucola, pachino' },
    { name: 'Fresca', price: '11,5€', description: 'Mozzarella, stracchino, guanciale, rucola, pachino' },
    { name: 'Contadina', price: '11,5€', description: 'Mozzarella, gorgonzola DOP, pera' },
    { name: 'Fiori', price: '10€', description: 'Mozzarella, fiori di zucca, acciughe' },
    { name: 'Rustichella', price: '12,5€', description: 'Mozzarella, gorgonzola, speck, noci' },
    { name: 'Patatona', price: '11€', description: 'Mozzarella, stracchino, guanciale, patate' },
    { name: 'Gustosa', price: '12€', description: 'Mozzarella, provola affumicata, prosciutto' },
  ],
  'PIZZE ROSSE': [
    { name: 'Marinara', price: '7€', description: 'Pomodoro, olio EVO, aglio, origano' },
    { name: 'Margherita', price: '7,5€', description: 'Pomodoro, mozzarella, basilico fresco' },
    { name: 'Bavarese', price: '8,5€', description: 'Pomodoro, mozzarella, wurstel' },
    { name: 'Salsiccia', price: '9€', description: 'Pomodoro, mozzarella, salsiccia' },
    { name: 'Napoli', price: '8,5€', description: 'Pomodoro, mozzarella, acciughe' },
    { name: 'Funghi', price: '8,5€', description: 'Pomodoro, mozzarella, funghi' },
    { name: 'Capricciosa', price: '10€', description: 'Pomodoro, mozzarella, uovo, carciofini, prosciutto S. Daniele, funghi' },
    { name: 'Diavola', price: '10€', description: 'Pomodoro, mozzarella, ventricina piccante' },
    { name: 'Bufala', price: '11€', description: 'Pomodoro, mozzarella di bufala, basilico fresco' },
    { name: 'Mediterranea', price: '11,5€', description: 'Pomodoro, mozzarella di bufala, capperi, olive' },
    { name: 'Sapporita', price: '11€', description: 'Pomodoro, mozzarella, tonno, cipolla' },
    { name: 'Amatriciana', price: '10€', description: 'Pomodoro, guanciale, pecorino romano, pomodoro a pezzi' },
    { name: 'Parmigiana', price: '10€', description: 'Pomodoro, mozzarella, melanzane, parmigiano, basilico' },
    { name: 'Ghiotta', price: '13€', description: 'Pomodoro, mozzarella, pomodorini gialli, pomodori secchi, fiocchi di bufala' },
  ],
  'DESSERT': [
    { name: 'Semifreddo di Nocciola', price: '8€', description: "Biscotto morbido e crumble all'arancia" },
    { name: 'Pannacotta di Latte di Bufala', price: '6€', description: 'A scelta: caramello, nutella o frutti di bosco' },
    { name: 'Tortino al Cioccolato Bianco', price: '9€', description: 'Con cuore caldo' },
    { name: 'Crostata Home Made', price: '5€' },
    { name: 'Tiramisù della Casa', price: '6€' },
    { name: 'Frutta di Stagione', price: '—' },
  ],
};

const categories = Object.keys(menuData);

const MenuSection = () => {
  const [activeCategory, setActiveCategory] = useState(categories[0]);

  return (
    <section id="menu" className="section-padding bg-[#222222] relative" data-testid="menu-section">
      <div className="art-deco-pattern" />
      <div className="max-w-7xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <p className="text-xs uppercase tracking-[0.2em] text-[#FFDA00] mb-4 font-semibold">
            Il Nostro Menu
          </p>
          <h2
            className="text-4xl md:text-5xl font-bold mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
            data-testid="menu-title"
          >
            Sapori Autentici Italiani
          </h2>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto">
            Una selezione di primi molto buoni e di pizze fatte a regola d'arte
          </p>
        </motion.div>

        {/* Category Tabs */}
        <div className="flex flex-wrap justify-center gap-2 mb-12" data-testid="menu-category-tabs">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-4 py-2 text-xs md:text-sm font-semibold uppercase tracking-wider transition-all duration-300 border ${
                activeCategory === cat
                  ? 'bg-[#FFDA00] text-[#222222] border-[#FFDA00]'
                  : 'bg-transparent text-gray-300 border-white/20 hover:border-[#FFDA00] hover:text-[#FFDA00]'
              }`}
              data-testid={`menu-tab-${cat.toLowerCase().replace(/\s+/g, '-')}`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Menu Items Grid */}
        <motion.div
          key={activeCategory}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="grid grid-cols-1 md:grid-cols-2 gap-6"
          data-testid={`menu-items-${activeCategory.toLowerCase().replace(/\s+/g, '-')}`}
        >
          {menuData[activeCategory].map((item, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: idx * 0.05 }}
              className="border-b border-white/10 pb-4 hover:border-[#FFDA00]/40 transition-colors"
              data-testid={`menu-item-${idx}`}
            >
              <div className="flex justify-between items-start gap-4 mb-1">
                <h4 className="text-white font-semibold text-base md:text-lg flex-1">
                  {item.name}
                </h4>
                <span className="text-[#FFDA00] font-bold whitespace-nowrap text-base md:text-lg">
                  {item.price}
                </span>
              </div>
              {item.description && (
                <p className="text-gray-400 text-sm mt-1 italic">{item.description}</p>
              )}
            </motion.div>
          ))}
        </motion.div>

        <p className="text-center text-gray-500 text-xs mt-12 italic">
          Menu soggetto a variazioni stagionali. Per allergeni e intolleranze rivolgersi al personale.
        </p>
      </div>
    </section>
  );
};

export default MenuSection;
